'use client';

import { useAppDispatch } from 'src/store/client/config';
import { modalActions } from 'src/store/client/slices/modalSlice';

import ModalButton from '@/app/(football)/[team]/_components/common/ModalButton';

interface GameResultModalProps {
  score: number;
  point: number;
  rank: number;
  remainingLives: number;
  onResetGame: () => void;
}

export default function GameResultModal({ score, point, rank, remainingLives, onResetGame }: GameResultModalProps) {
  const dispatch = useAppDispatch();

  // Display 999+ if rank exceeds 999
  const formattedRank = rank > 999 ? '999+' : rank;

  const handleCloseModal = () => {
    dispatch(modalActions.closeModal());
    onResetGame();
  };

  return (
    <div className="flex w-[320px] flex-col items-center rounded-lg bg-g-00 px-5 py-6">
      <div className="flex w-full flex-col items-center gap-4">
        <p className="typo-body-1 text-center text-g-90">게임결과</p>
        <div className="flex w-full flex-col gap-2.5 rounded border border-g-30 px-5 py-3">
          <div className="flex w-full items-center justify-between text-base font-medium leading-5">
            <div className="typo-body-5 text-g-90">블록층수</div>
            <div className="typo-body-4 text-right text-g-90">
              {score ?? '-'}층
            </div>
          </div>
          <div className="flex w-full items-center justify-between text-base font-medium leading-5">
            <div className="typo-body-5 text-g-90">획득 포인트</div>
            <div className="typo-body-4 text-right text-g-90">
              {point ? `${point}` : '-'}P
            </div>
          </div>
          <div className="flex w-full items-center justify-between text-base font-medium leading-5">
            <div className="typo-body-5 text-g-90">최종 랭킹</div>
            <div className="typo-body-4 text-right text-g-90">
              {rank ? `${formattedRank}위` : '-'}
            </div>
          </div>
          <div className="flex w-full items-center justify-between text-base font-medium leading-5">
            <div className="typo-body-5 text-g-90">참여 횟수</div>
            <div className="typo-body-4 text-right text-g-90">
              {10 - remainingLives}/10회
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 flex w-full items-center">
        <ModalButton
          variant="primary"
          onClick={handleCloseModal}
        >
          확인
        </ModalButton>
      </div>
    </div >
  );
}
